import React from 'react';
import '../../cssFiles/celebration.scss';

let Celebration = () => {
    return (
        <div  className="celebration-layout">    
            {/* <img src="/images/celebration/celebrating10yeras.png" alt="Research Desk" className="celebration-img" /> */}
            
            <div className='customer-count'>
                <img src="/images/celebration/celebrating10yeras.png" alt="Research Desk" className="celebration-img" />
                <div className='customer-count-group'>
                    <div>
                        <div>4,00,000+</div>
                        <div className='customer-count-desc'>Registered Members</div>
                    </div>
                    <div>
                        <div>14,000+</div>
                        <div className='customer-count-desc'>Paid Subscribers</div>
                    </div>
                </div>

                {/* <img src="/images/celebration/celebrating10yeras.png" alt="Research Desk" className="celebration-img" /> */}
                
                {/* <div>
                    <div>80+</div>
                    <div className='customer-count-desc'>Employees</div>
                </div> */}
            </div>

            <div className='appreared-on'>
                <p>Appeared on</p>
                <div className='appreared-on-list'>
                    <img src="/images/appeared/Business-world.png" alt="Research Desk" className="aboutus-research-desk" />
                    <img src="/images/appeared/PTI.png" alt="Research Desk" className="aboutus-research-pti" />
                </div>
                <img src="/images/appeared/Financial-express.png" alt="Research Desk" className="aboutus-research-desk-financial-exp" />
            </div>
        </div>
    )
}

export default Celebration;